// Basic
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useRootOrganizationStore from '@/app/store/rootOrganization';
import usePlansStore from '@/app/store/modules/plan';
import actionsPlans from '../../api/actionsPlans';
// Components
import DataTable from '@/common-utils/components/renders/dataTable/DataTable';
// Common
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';
import { columnsPlans, columnsPlansId } from './columnsDef/columnsPlans';

/**
 * @param root0
 * @param root0.singleSelection
 * @param root0.rowsSelected
 * @param root0.setRowsSelected
 * @param root0.organizationId
 * @param root0.pageActions
 * @param root0.filtersEventName
 *@returns {JSX} PlansTable
 */
function PlansTable({
    organizationId = undefined,
    singleSelection = false,
    rowsSelected = undefined,
    setRowsSelected = undefined,
    pageActions = undefined,
    filtersEventName
}) {

    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { refetchPlans: refetchFromStore, storeRefetchPlans, storeShouldBlockNewPos, query: queryStored, storeQuery } = usePlansStore();

    // Constants
    const initialQuery = getInitialQuery();
    const selectionMode = !!(rowsSelected && setRowsSelected);

    // State
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));
    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { data, isFetching, refetch } = actionsPlans.getPlans({ query: query, organizationId: organizationId || rootOrganization.uuid }, false);

    // Hooks
    useEffect(() => {
        if (rootOrganization && (launchRefetch || refetchFromStore)) {
            refetch();
            setLaunchRefetch(false);
            storeRefetchPlans(false);
        }
    }, [query, refetchFromStore, launchRefetch]);

    useEffect(() => {
        if (data) {
            const { shouldBlockNewPOS } = data;
            storeShouldBlockNewPos(shouldBlockNewPOS);
        }
    }, [data]);

    // Columns
    const allColumns = columnsPlans({
        query,
        setQuery,
        queryStored,
        storeQuery,
        setLaunchRefetch,
        selectionMode,
        singleSelection,
        displayParentPlanLabel: true,
        filtersEventName
    });

    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            columnsId={columnsPlansId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQuery}
            setLaunchRefetch={setLaunchRefetch}

            selectionMode={selectionMode}
            singleSelection={singleSelection}
            rowsSelected={rowsSelected}
            setRowsSelected={setRowsSelected}

            pageActions={pageActions}
        />
    );
}

PlansTable.propTypes = {
    organizationId: PropTypes.string,
    singleSelection: PropTypes.bool,
    rowsSelected: PropTypes.any,
    setRowsSelected: PropTypes.func,
    pageActions: PropTypes.node,
    filtersEventName: PropTypes.string
};

export default PlansTable;